<template>
    <b-row class="min-vh-100">
        <b-col md="5" order="2" order-sm="2" order-md="1" class="auth-form-column">
            <div class="auth-form">
                <h1 v-html="$t('login.title')"></h1>
                <p v-html="$t('login.description')"></p>
                <b-form novalidate class="needs-validation" autocomplete="off">
                    <b-form-group :label="$t('login.input.email_label')" label-for="email">
                        <b-form-input
                            id="email"
                            v-model="email"
                            type="email"
                            required
                            :placeholder="$t('login.input.email_placeholder')"
                        ></b-form-input>
                        <b-form-invalid-feedback tag="span">{{ errors.email }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="$t('login.input.password_label')" label-for="password">
                        <b-form-input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            :placeholder="$t('login.input.password_placeholder')"
                        ></b-form-input>
                        <b-form-invalid-feedback tag="span">{{ errors.password }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group class="mt-2">
                        <b-button type="submit" variant="primary" @click.prevent="login" block :style="{'border-radius': 0, 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                            {{ $t('login.button.login') }} <span class="icon-arrow-btn ml-3"></span>
                        </b-button>
                    </b-form-group>
                </b-form>
                <p class="text-center" style="color: #A5A5A5;">- {{ $t('login.or') }} -</p>
                <social-login-buttons></social-login-buttons>
                <p><router-link :to="{name:'reset_password'}">{{ $t('login.forgot_password') }}</router-link></p>
                <p class="font-weight-bold">
                    {{ $t('login.register') }}
                    <router-link :to="{name:'register'}">{{$t('login.register_link')}}</router-link>
                </p>
            </div>
        </b-col>
        <app-intro></app-intro>
    </b-row>
</template>

<script>
    import {errors} from '../../mixins/errors';
    import socialLoginButtons from './social-buttons';

    export default {
        name: 'login',
        mixins: [
            errors
        ],
        components: {
            'social-login-buttons': socialLoginButtons
        },
        data() {
            return {
                email: '',
                password: ''
            };
        },
        methods: {
            login() {
                let data = {
                    email: this.email,
                    password: this.password
                };

                this.$store.dispatch('auth/login', data).catch(e => {
                    this.handleResponseErrors(e);
                });
            }
        },
        mounted() {
            this.validationHandler()
        }
    }
</script>
